// ProgressTracker.js

import React, { useContext, useEffect, useState } from "react";
import "./index.css";
import AppointmentCard from "../../components/common/appointmentCard";
import FormRendererContext from "../../services/context/FormRendererContext";

const ScheduleAppointment = ({ data, activateNextClick }) => {
  const { journeyConfigsGlobal } = useContext(FormRendererContext);
  const schedulerConfig = journeyConfigsGlobal?.scheduler;
  const hideDoctorDetails = schedulerConfig?.hideDoctorDetails || false;
  const schedulerInfo = schedulerConfig?.schedulerInfo;

  return (
    <div
      className={`pb-5 px-5 ${
        schedulerInfo && schedulerInfo !== "" ? "" : "pt-10"
      }`}
    >
      <div>
        <div
          className={`appointment mx-auto pb-10 pt-3 w-full ${
            hideDoctorDetails ? "max-w-[900px] m-auto" : "container"
          }`}
        >
          <div className="calendar ">{/* <DateRangePickerComponent /> */}</div>
          {data &&
            data.length &&
            data.map((item, index) => {
              return (
                <div className="py-3 appoint-card">
                  <AppointmentCard
                    doctorData={item?.providerDetail[0]}
                    providerId={item?.providerId}
                    key={index}
                    activateNextClick={(appointmentId, appointmentSlotData) =>
                      activateNextClick(appointmentId, appointmentSlotData)
                    }
                  />
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default ScheduleAppointment;
